/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapProjecting = createReactComponent("outline", "cap-projecting", "IconCapProjecting", [["path", { "d": "M20 6h-13a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h13", "key": "svg-0" }], ["path", { "d": "M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-1" }], ["path", { "d": "M13 12h7", "key": "svg-2" }]]);

export { IconCapProjecting as default };
//# sourceMappingURL=IconCapProjecting.mjs.map
